import { useEffect, useState } from "react";
import { getLoggedinUser, TokenManager } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = userProfileSession && userProfileSession["token"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );
  const [isSuperAdmin, setIsSuperAdmin] = useState(TokenManager.isSuperAdmin());

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =
      userProfileSession &&
      userProfileSession["token"];
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
    setIsSuperAdmin(TokenManager.isSuperAdmin());
  }, []);


  return { userProfile, loading, token, isSuperAdmin };
};

export { useProfile };